export enum TicketDepartmentRouteName {
    Index = 'ticket-departments.index',
    Create = 'ticket-departments.create',
    Edit = 'ticket-departments.edit',
}

export default {
    path: 'ticket-departments',
    name: TicketDepartmentRouteName.Index,
    component: () => import('./pages/index.vue'),
    meta: {
        label: 'Ticket Departments',
        icon: 'fal fa-building fa-fw',
        location: 'sidebar',
        permission: 'manage-tickets',
        auth: true,
        group: 'main',
    },
    children: [
        {
            path: 'create',
            name: TicketDepartmentRouteName.Create,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Create Ticket Department',
                permission: 'manage-tickets',
                group: 'main',
            },
        },
        {
            path: ':ticketDepartmentUuid/edit',
            name: TicketDepartmentRouteName.Edit,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Edit Ticket Department',
                permission: 'manage-tickets',
                group: 'main',
            },
        },
    ],
}
